"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFailureNodeStatus = void 0;
function isFailureNodeStatus(status) {
    if (!status)
        return false;
    const failStatus = ['failed-to-enter', 'aborted', 'error'];
    return failStatus.includes(status);
}
exports.isFailureNodeStatus = isFailureNodeStatus;
//# sourceMappingURL=isFailureNodeStatus.js.map